import React from 'react';
import './Explore.css'
import { Link } from 'react-router-dom';

const Explore = () => {
    return (
        
        <section className="exploring-section">
            {/* === Explore sextion === */}
            <div className="container">
                <div className="exploring-main-content">
                    <div className="exploring-left" style={{backgroundImage: `url('/img/left.webp')`}}>
                        <div className="overlay">
                            <h4 className="top-heading">FOR BUSINESSES</h4>
                            <h2 className="middle-heading">Industry leading event management app</h2>
                            <p className="exploring-text">Join our growing family of suppliers by registering your interest for our exciting new app.</p>
                            <Link to="/business" className="business-btn home-btn">START GROWING</Link>
                        </div>
                    </div>
                    <div className="exploring-right" style={{backgroundImage: `url('/img/right.webp')`}}>
                        <div className="overlay">
                            <h4 className="top-heading">FOR EVERYONE</h4>
                            <h2 className="middle-heading">Game changing party planning app, at your fingertips</h2>
                            <p className="exploring-text">Find suppliers & businesses near you with Elite Partyz, and discover everything you need to make the best party yet.</p>
                            <Link to="/members" className="public-btn home-btn">START EXPLORING</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Explore
